import { useEffect, useRef } from 'react'
import Spiderfy from '@nazka/map-gl-js-spiderfy'

const spiderLeavesLayout = {
  'icon-image': [
    'case',
    ['==', ['get', 'status'], 'active'], 'nazka_trap',
    ['==', ['get', 'status'], 'passive'], 'nazka_trap-passive',
    ['==', ['get', 'status'], 'inactive'], 'nazka_trap-inactive',
    'nazka_trap-inactive',
  ],
}

function useLatestRef(value) {
  const ref = useRef(value)

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref
}

function useTrapSpiderfy({ map, layerId = 'trap-layer', closeOnLeafClick, onLeafClick, onLeafHover }) {
  const spiderfyRef = useRef(null)
  const onLeafClickRef = useLatestRef(onLeafClick)
  const onLeafHoverRef = useLatestRef(onLeafHover)

  useEffect(() => {
    if (!map) return

    let isMounted = true

    const cleanupSpiderfy = () => {
      if (!spiderfyRef.current) return

      spiderfyRef.current.unspiderfyAll()
      spiderfyRef.current = null
    }

    const initSpiderfy = () => {
      if (!isMounted || spiderfyRef.current || !map.getLayer(layerId)) return

      const options = {
        forceSpiderifyMinZoom: 18,
        spiderLeavesLayout,
        spiderLeavesPaint: {},
      }

      if (closeOnLeafClick !== undefined) {
        options.closeOnLeafClick = closeOnLeafClick
      }

      if (onLeafClickRef.current) {
        options.onLeafClick = (...args) => onLeafClickRef.current?.(...args)
      }

      if (onLeafHoverRef.current) {
        options.onLeafHover = (...args) => onLeafHoverRef.current?.(...args)
      }

      spiderfyRef.current = new Spiderfy(map, options)
      spiderfyRef.current.applyTo(layerId)
    }

    initSpiderfy()
    map.once('idle', initSpiderfy)
    map.on('styledata', initSpiderfy)

    return () => {
      isMounted = false
      map.off('idle', initSpiderfy)
      map.off('styledata', initSpiderfy)
      cleanupSpiderfy()
    }
  }, [closeOnLeafClick, layerId, map, onLeafClickRef, onLeafHoverRef])
}

export default useTrapSpiderfy
